import { TrainingEvent } from '@alucio/aws-beacon-amplify/src/models'
import { API, graphqlOperation, GraphQLResult } from '@aws-amplify/api';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
  commonReducers,
  initialState,
  SliceStatus,
} from './common'
import { listTrainingEvents } from '@alucio/aws-beacon-amplify/src/graphql/queries';
import {
  ListTrainingEventsQuery,
  CreateTrainingEventMutation,
  UpdateTrainingEventMutation,
} from '@alucio/aws-beacon-amplify/src/API';
import { createTrainingEvent, updateTrainingEvent } from '@alucio/aws-beacon-amplify/src/graphql/mutations';
import * as logger from 'src/utils/logger';

const sliceName = 'trainingEvent'
const { reducers } = commonReducers<TrainingEvent>(sliceName)

const getTrainingEvents = createAsyncThunk(
  'trainingEvent/getTrainingEvents',
  async (tenantId: string) => {
    const { data } = await API.graphql(graphqlOperation(listTrainingEvents, {
      filter: { tenantId: { eq: tenantId } },
    })) as GraphQLResult<ListTrainingEventsQuery>
    return data?.listTrainingEvents
  },
)

const saveTrainingEvent = createAsyncThunk(
  'trainingEvent/saveTrainingEvent',
  async (trainingEventPayload: TrainingEvent) => {
    try {
      const { data } = await API.graphql(graphqlOperation(createTrainingEvent, {
        input: { ...trainingEventPayload },
      })) as GraphQLResult<CreateTrainingEventMutation>
      return data?.createTrainingEvent
    } catch (err) {
      logger.trainingEvent.error('error in creating training event', err)
      throw new Error('error in creating training event')
    }
  },
)

const editTrainingEvent = createAsyncThunk(
  'trainingEvent/updateTrainingEvent',
  async (trainingEventPayload: TrainingEvent) => {
    try {
      const response = await API.graphql({
        query: updateTrainingEvent,
        variables: { input: trainingEventPayload },
      })
      return response
    } catch (err) {
      logger.trainingEvent.error('error in updating training event', err)
      throw new Error('error in updating training event')
    }
  },
)

const removeTrainingEvent = createAsyncThunk(
  'trainingEvent/deleteTrainingEvent',
  async (trainingEventPayload: TrainingEvent) => {
    try {
      const { data } = await API.graphql(graphqlOperation(updateTrainingEvent, {
        input : {
          ...trainingEventPayload,
          deleted: true,
        },
      })) as GraphQLResult<UpdateTrainingEventMutation>
      return data
    } catch (err) {
      logger.trainingEvent.error('error in deleting training event', err)
      throw new Error('error in deleting training event')
    }
  },
)

const trainingEventSlice = createSlice({
  name: sliceName,
  initialState: initialState<TrainingEvent>(),
  reducers: {
    ...reducers,
  },
  extraReducers: {
    [getTrainingEvents.fulfilled.toString()]: (state, resp) => {
      state.status = SliceStatus.OK;
      state.hydrated = true;
      state.records = resp.payload.items;
    },
    [getTrainingEvents.rejected.toString()]: (state) => {
      state.status = SliceStatus.ERROR;
    },
  },
})

export default trainingEventSlice
export const trainingEventActions = {
  ...trainingEventSlice.actions,
  getTrainingEvents,
  saveTrainingEvent,
  editTrainingEvent,
  removeTrainingEvent,
}
